<template>
	<div>
		<!-- Start leftpart -->
		<div class="leftpart">
			<div class="leftpart_inner">
				<div class="logo">
					<a href="/" style="cursor: pointer"
						><img src="../assets/img/logo/dark.png" alt=""
					/></a>
				</div>
				<!-- End .logo -->
				<div class="menu">
					<a href="/" :class="[activetab === 1 ? 'active' : '']">
						<img
							class="svg"
							src="../assets/img/svg/home-run.svg"
							alt="homerun"
						/>
						<span class="menu_content">Home</span></a
					>
					<!-- End Home -->
					<a href="/about" :class="[activetab === 2 ? 'active' : '']">
						<img class="svg" src="../assets/img/svg/avatar.svg" alt="avatar" />
						<span class="menu_content">About</span></a
					>
					<!-- End About -->
					<a href="/portfolio" :class="[activetab === 3 ? 'active' : '']">
						<img
							class="svg"
							src="../assets/img/svg/briefcase.svg"
							alt="briefcase"
						/>
						<span class="menu_content">Portfolio</span></a
					>
					<!-- End Portfolio -->
					<a
						href="/writing-tr"
						v-on:click="activetab = 4"
						:class="[activetab === 4 ? 'active' : '']"
						><img
							class="svg"
							src="../assets/img/svg/quote.svg"
							alt="paper"
						/><span class="writing-lang">[TR]</span>
						<span class="menu_content">Writing [TR]</span></a
					>
					<a
						href="/writing-en"
						v-on:click="activetab = 5"
						:class="[activetab === 5 ? 'active' : '']"
						><img
							class="svg"
							src="../assets/img/svg/quote.svg"
							alt="paper"
						/><span class="writing-lang">[EN]</span>
						<span class="menu_content">Writing [EN]</span></a
					>
					<a href="/contact" :class="[activetab === 6 ? 'active' : '']">
						<img class="svg" src="../assets/img/svg/mail.svg" alt="mail" />
						<span class="menu_content"> Contact</span></a
					>
					<!-- End Contact -->
				</div>
				<div class="copyright">
					<p>
						Created by
						<a href="#" target="_blank" rel="noreferrer"> Abdullah Gürsoy </a>
						&copy; {{ new Date().getFullYear() }}
					</p>
				</div>
				<!-- End copyright -->
			</div>
		</div>
		<!-- End leftpart -->

		<!-- Start rightpart -->
		<div class="rightpart">
			<div class="rightpart_in">
				<div class="tokyo_tm_section">
					<div class="container">
						<div v-if="activetab === 1" class="tabcontent">
							<Home />
						</div>
						<div v-if="activetab === 2" class="tabcontent">
							<About />
						</div>
						<div v-if="activetab === 3" class="tabcontent">
							<Portfolio />
						</div>
						<div v-if="activetab === 4" class="tabcontent">
							<WritingTR />
						</div>
						<div v-if="activetab === 5" class="tabcontent">
							<WritingEN />
						</div>
						<div v-if="activetab === 6" class="tabcontent">
							<Contact />
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- End rightpart -->
	</div>
</template>

<script>
import Home from "../components/Home";
import About from "../components/About";
import Portfolio from "../components/Portfolio";
import WritingTR from "../components/WritingTR";
import WritingEN from "../components/WritingEN";
import Contact from "../components/Contact";
export default {
	components: {
		Home,
		About,
		Portfolio,
		WritingTR,
		WritingEN,
		Contact,
	},
	data() {
		return {
			activetab: 1,
		};
	},
	mounted() {
		if (this.$route.params.path) {
			switch (this.$route.params.path) {
				case "/":
					this.activetab = 1;
					break;
				case "about":
					this.activetab = 2;
					break;
				case "portfolio":
					this.activetab = 3;
					break;
				case "writing-tr":
					this.activetab = 4;
					break;
				case "writing-en":
					this.activetab = 5;
					break;
				case "contact":
					this.activetab = 6;
					break;
			}
		}
	},
};
</script>

<style lang="scss" scoped>
body::-webkit-scrollbar {
	display: none;
}

@media only screen and (max-width: 768px) {
	.logo img {
		height: 50px !important;
	}

	.writing-lang {
		display: block !important;
	}
}

.writing-lang {
	margin-top: -5px;
	margin-left: -3px;
	font-size: 8px;
	display: none;
}
</style>
